export enum FirestoreCollectionIDs {
  PROCESS_TYPES = 'processTypes',
  PROCESS_TYPE_STATUSES = 'processTypeStatuses',
  USERS = 'users',
  DELIVERIES = 'deliveries',
  REPORTS = 'reports',
  DELIVERY_ROUTES = 'deliveryRoutes',
  ROUTE_LOGS = 'routeLogs',
  META = 'meta',
  DRIVER_MESSAGES = 'driverMessages',
  LOCATIONS = 'locations',
  SUB_LOCATIONS = 'subLocations',
  VEHICLES = 'vehicles',
  SETTINGS_VEHICLE_CHECKS = 'settingsVehicleChecks',
  VEHICLE_CHECKS = 'vehicleChecks',
  RUNS = 'runs',
  RUN_LOCATIONS = 'runLocations',
  ALERTS = 'alerts',
  RUN_ACTIVITY = 'runActivity',
  SHIFT_ACTIVITY = 'shiftActivity',
  CONSIGNMENTS = 'consignments',
  TRANSPORT_JOBS = 'transportJobs',
  RDC_CONSIGNMENTS = 'rdcConsignments',
  DELIVERY_REQUESTS = 'deliveryRequests',
  TRANSPORT_GROUPS = 'transportGroups',
  JOTFORM_SUBMISSIONS = 'jotformSubmissions',
  WEBHOOK_SETTINGS = 'webhookSettings',
}
